<template>
  <div class="main">
    <div class="ManualNotification">
      <div class="ManualNotification-main">
        <module-title title="">
          <div class="right">
            <el-button
              type="primary"
              size="medium"
              @click="opAdd"
            >
              批量添加
            </el-button>
          </div>
        </module-title>
        <div class="ManualNotification-main-contain">
          <el-form ref="searchForm" :model="searchForm" :rules="searchFormRules" :inline="true" label-position="right" label-width="100px">
            <el-form-item label="发送时间：" prop="dateTime">
              <el-date-picker
                v-model="dateValue"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="dateChange"
              />
            </el-form-item>
            <el-form-item label="用户账号：" prop="userPhone">
              <el-input
                v-model="searchForm.userPhone"
                name="name"
                placeholder="请输入用户账号"
              />
            </el-form-item>
            <el-form-item label="发送状态：" prop="smsStatus">
              <el-select
                v-model="searchForm.smsStatus"
                name="smsStatus"
                size="medium"
                class="handle-form-input"
              >
                <el-option label="全部" value="" />
                <el-option
                  v-for="item in statusArr"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-search"
                @click="handleSearchFilter"
              >
                查询
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="medium"
                @click="resetInput"
              >
                重置
              </el-button>
            </el-form-item>
          </el-form>
          <el-table
            v-loading="listLoading"
            :data="applicationList"
            highlight-current-row
            fit
            element-loading-text="Loading"
            class="list-table"
          >
            <el-table-column type="index" width="55" align="center" label="序号" />
            <el-table-column label="用户账号" prop="userPhone" align="center" />
            <el-table-column label="SN号" prop="deviceNo" align="center" />
            <el-table-column label="发送时间" prop="sendDate" align="center" />
            <el-table-column label="发送状态" prop="sendStatusName" align="center" />
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.sendStatus !== 1"
                  type="text"
                  size="mini"
                  @click="handleSendNotification(scope.row)"
                >
                  发送通知
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="searchForm.total"
            :page.sync="searchForm.pageNum"
            :limit.sync="searchForm.pageSize"
            @pagination="pageCurriculumList"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
      <el-dialog
        v-if="hiddenVariable.dialogUploadVisiblePackage"
        :close-on-click-modal="false"
        :visible.sync="hiddenVariable.dialogUploadVisiblePackage"
        title="批量导入"
        width="540px"
      >
        <el-form
          label-position="right"
        >
          <el-form-item style="textAlign:center">
            <el-button type="primary" style=" margin-bottom: 20px;vertical-align: top" icon="el-icon-upload2" size="medium" @click="handlerExcelTemplate">
              下载模板
            </el-button>
            <el-upload
              ref="upload"
              :on-success="onSuccess"
              :action="uploadUrl"
              :headers="uploadHeader"
              :on-progress="onProgress"
              :on-error="onError"
              :multiple="false"
              :limit="1"
              name="file"
              accept=".xls, .xlsx"
              class="handle-btn"
            >
              <el-button
                :loading="hiddenVariable.fileUploading"
                size="medium"
                type="primary"
                icon="el-icon-upload2"
              >
                {{ hiddenVariable.fileUploading?'上传文件中...':'上传文件' }}
              </el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 批量导入异常 -->
      <el-dialog
        :close-on-click-modal="false"
        :visible.sync="hiddenVariable.dialogMultipleImportVisible"
        title="异常数据"
      >
        <p style="padding:0 0 20px 20px;">
          导入失败，存在{{ abnormalDataList.length }}条异常记录，请修改后重新上传
        </p>
        <el-scrollbar wrap-class="abnormal-table">
          <el-table
            :data="abnormalDataList"
            fit
            highlight-current-row
          >
            <el-table-column type="index" width="55" align="center" label="序号" />
            <el-table-column label="异常原因" prop="errorMsg" align="center">
              <template slot-scope="scope">
                <span style="color:red">{{ scope.row.errorMsg }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </el-dialog>
      <!-- 发送失败弹框 -->
      <el-dialog
        :close-on-click-modal="false"
        title="发送通知失败"
        :visible.sync="hiddenVariable.dialogNotificationFailInfo"
        width="650px"
      >
        <div class="dialogNotification">
          <div class="info">
            发送失败对象：{{ sendFailMobile.join(",") }}
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';
import { validatEecgRegisterNumber } from '@/utils/validate';
import { getRemindersManualList, getUpgradeRemindersTemplateExport, getUpgradeRemindersManualImport, sendRemindersManual } from '@/api/productOperation/mrDesk/upgradeSMSNotification';

export default {
  name: 'ManualNotification',
  data() {
    return {
      ajaxLoading: false,
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogUploadVisiblePackage: false,
        fileUploading: false, // 文件上传加载
        dialogMultipleImportVisible: false,
        dialogNotificationFailInfo: false
      },
      // 搜索表单
      searchForm: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        userPhone: '',
        smsStatus: '',
        startCreateDate: null,
        endCreateDate: null
      },
      dateValue: '',
      abnormalDataList: [],
      listLoading: false, // 表格刷新loading
      applicationList: [],
      uploadUrl: '', // 上传文件URL
      uploadHeader: {},
      searchFormRules: {
        userPhone: [{ validator: validatEecgRegisterNumber, trigger: 'blur' }]
      },
      sendFailMobile: []
    };
  },
  computed: {
    statusArr() {
      return [
        {
          code: 1, name: '发送成功'
        },
        {
          code: 0, name: '发送失败'
        }
      ];
    }
  },
  mounted() {
    this.fetchNotificationList();
    this.initUploadData();
  },
  methods: {
    // 初始化上传数据
    initUploadData() {
      const accessToken = getToken();
      this.uploadHeader = {
        Authorization: `Bearer ${accessToken}`
      };
      this.uploadUrl = getUpgradeRemindersManualImport(); // 导入
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchNotificationList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchNotificationList();
    },
    // 重置
    resetInput() {
      this.dateValue = '';
      this.searchForm = { ...this.searchForm, userPhone: '', smsStatus: '', startCreateDate: null, endCreateDate: null };
      this.fetchNotificationList();
    },
    dateChange(e) {
      if (e) {
        this.searchForm.startCreateDate = e[0];
        this.searchForm.endCreateDate = e[1];
      } else {
        this.searchForm.startCreateDate = '';
        this.searchForm.endCreateDate = '';
      }
    },
    // 条件查询
    handleSearchFilter() {
      this.$refs['searchForm'].validate((valid) => {
        if (valid) {
          this.searchForm.pageNum = 1;
          this.searchForm.pageSize = 10;
          this.fetchNotificationList();
        }
      });
    },
    // 打开导入弹框
    opAdd() {
      this.hiddenVariable.dialogUploadVisiblePackage = true;
    },
    // 获取表格数据
    fetchNotificationList() {
      this.listLoading = true;
      getRemindersManualList(this.searchForm)
        .then((result) => {
          this.applicationList = result.data.list;
          this.searchForm.total = result.data.total;
          this.listLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.listLoading = false;
          this.applicationList = [];
          this.searchForm.total = 0;
        });
    },
    // 下载模板
    handlerExcelTemplate() {
      window.location.href = getUpgradeRemindersTemplateExport();
    },
    // 导入上传成功
    onSuccess(response, file, fileList) {
      this.hiddenVariable.fileUploading = false;
      this.$refs.upload.clearFiles();
      if (response.code === '0') {
        this.$message({
          message: '文件上传成功',
          type: 'success'
        });
        this.fetchNotificationList();
        this.hiddenVariable.dialogUploadVisiblePackage = false;
      } else if (response.code === '12007' && response.errorData) {
        this.hiddenVariable.dialogMultipleImportVisible = true;
        const list = response.data;
        this.abnormalDataList = list.map(v => {
          return { errorMsg: v };
        });
      } else {
        if (response.errorData) {
          this.sendFailMobile = response.errorData;
          this.hiddenVariable.dialogNotificationFailInfo = true;
        } else {
          this.$message({
            message: response.message,
            type: 'error'
          });
        }
      }
    },
    // 导入 加载
    onProgress() {
      this.hiddenVariable.fileUploading = true;
    },
    onError() {
      this.hiddenVariable.fileUploading = false;
      this.$message({
        message: '文件上传失败',
        type: 'error'
      });
    },
    // 发送通知
    handleSendNotification(row) {
      sendRemindersManual({ recordIds: [row.id] + '' })
        .then((response) => {
          if (response.code === '0' && !response.errorData) {
            this.$message({
              message: '发送成功',
              type: 'success'
            });
            this.fetchNotificationList();
          } else if (response.errorData) {
            this.sendFailMobile = response.errorData;
            this.hiddenVariable.dialogNotificationFailInfo = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.ManualNotification {
  .dialogNotification {
    .info {
      margin-bottom: 30px;
    }
  }
}
</style>
